import { NucleusError } from '@nucleus/ncu-error';

/**
 * @deprecated use `import { UnableToParseError } from '@nucleus/ncu-key-prefix'` instead
 */
export class UnableToParseError extends NucleusError {
  override name = 'UnableToParseError';
}
